@file:OptIn(InternalResourceApi::class)

package tregz.tremenz.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tregz.tremenz.shared.generated.resources/"

@delegate:ResourceContentHash(-2_001_921_812)
public val Res.drawable.ic_beer: DrawableResource by lazy {
      DrawableResource("drawable:ic_beer", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_beer.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-670_080_140)
public val Res.drawable.ic_cocktail: DrawableResource by lazy {
      DrawableResource("drawable:ic_cocktail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cocktail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(248_141_017)
public val Res.drawable.ic_collapse: DrawableResource by lazy {
      DrawableResource("drawable:ic_collapse", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_collapse.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-187_441_118)
public val Res.drawable.ic_contact: DrawableResource by lazy {
      DrawableResource("drawable:ic_contact", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_contact.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_634_373_606)
public val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_788_684_839)
public val Res.drawable.ic_expand: DrawableResource by lazy {
      DrawableResource("drawable:ic_expand", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_expand.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(930_667_096)
public val Res.drawable.ic_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_643_252_018)
public val Res.drawable.ic_instant_mix: DrawableResource by lazy {
      DrawableResource("drawable:ic_instant_mix", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_instant_mix.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_436_393_191)
public val Res.drawable.ic_library_video: DrawableResource by lazy {
      DrawableResource("drawable:ic_library_video", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_library_video.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_551_019_660)
public val Res.drawable.ic_light_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-88_080_884)
public val Res.drawable.ic_media_output: DrawableResource by lazy {
      DrawableResource("drawable:ic_media_output", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_media_output.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(475_539_053)
public val Res.drawable.ic_news: DrawableResource by lazy {
      DrawableResource("drawable:ic_news", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_news.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_984_522_840)
public val Res.drawable.ic_pause: DrawableResource by lazy {
      DrawableResource("drawable:ic_pause", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pause.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-309_791_378)
public val Res.drawable.ic_photos: DrawableResource by lazy {
      DrawableResource("drawable:ic_photos", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_photos.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_153_990_543)
public val Res.drawable.ic_play: DrawableResource by lazy {
      DrawableResource("drawable:ic_play", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_play.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_106_121_182)
public val Res.drawable.ic_queue_music: DrawableResource by lazy {
      DrawableResource("drawable:ic_queue_music", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_queue_music.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_109_245_480)
public val Res.drawable.ic_radio: DrawableResource by lazy {
      DrawableResource("drawable:ic_radio", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radio.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_107_177_534)
public val Res.drawable.ic_tremenz: DrawableResource by lazy {
      DrawableResource("drawable:ic_tremenz", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tremenz.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(926_711_480)
public val Res.drawable.ic_tv: DrawableResource by lazy {
      DrawableResource("drawable:ic_tv", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tv.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_267_416_125)
public val Res.drawable.ic_wine: DrawableResource by lazy {
      DrawableResource("drawable:ic_wine", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_wine.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-742_666_759)
public val Res.drawable.ic_wordmark: DrawableResource by lazy {
      DrawableResource("drawable:ic_wordmark", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_wordmark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_127_550_523)
public val Res.drawable.me_orange: DrawableResource by lazy {
      DrawableResource("drawable:me_orange", setOf(
        ResourceItem(setOf(), "${MD}drawable/me_orange.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-353_481_561)
public val Res.drawable.me_red_cue: DrawableResource by lazy {
      DrawableResource("drawable:me_red_cue", setOf(
        ResourceItem(setOf(), "${MD}drawable/me_red_cue.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_843_658_199)
public val Res.drawable.me_red_mix: DrawableResource by lazy {
      DrawableResource("drawable:me_red_mix", setOf(
        ResourceItem(setOf(), "${MD}drawable/me_red_mix.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_beer", Res.drawable.ic_beer)
  map.put("ic_cocktail", Res.drawable.ic_cocktail)
  map.put("ic_collapse", Res.drawable.ic_collapse)
  map.put("ic_contact", Res.drawable.ic_contact)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_expand", Res.drawable.ic_expand)
  map.put("ic_info", Res.drawable.ic_info)
  map.put("ic_instant_mix", Res.drawable.ic_instant_mix)
  map.put("ic_library_video", Res.drawable.ic_library_video)
  map.put("ic_light_mode", Res.drawable.ic_light_mode)
  map.put("ic_media_output", Res.drawable.ic_media_output)
  map.put("ic_news", Res.drawable.ic_news)
  map.put("ic_pause", Res.drawable.ic_pause)
  map.put("ic_photos", Res.drawable.ic_photos)
  map.put("ic_play", Res.drawable.ic_play)
  map.put("ic_queue_music", Res.drawable.ic_queue_music)
  map.put("ic_radio", Res.drawable.ic_radio)
  map.put("ic_tremenz", Res.drawable.ic_tremenz)
  map.put("ic_tv", Res.drawable.ic_tv)
  map.put("ic_wine", Res.drawable.ic_wine)
  map.put("ic_wordmark", Res.drawable.ic_wordmark)
  map.put("me_orange", Res.drawable.me_orange)
  map.put("me_red_cue", Res.drawable.me_red_cue)
  map.put("me_red_mix", Res.drawable.me_red_mix)
}
